import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import * as Sentry from "@sentry/react";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Backdrop from "@material-ui/core/Backdrop";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import queryString from "query-string";
import { useHistory, useLocation } from "react-router-dom";
import { CoinContext } from "../../contexts/CoinContext";
import "./index.css";
import { REACT_APP_PROD_URL, SITE_KEY_CAPTCHA } from "../../services/configs";

import loaderGif from "../../assets/img/loader.gif";
import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch, useSelector } from "react-redux";
import fetcher from "../../api/swr_fetcher";

import { nanoid } from "nanoid/async";
import { deleteFreshchat } from "../../services/freshchat";
// import { AuthContext } from '../../contexts/AuthContext'

import SimpleImageSlider from "react-simple-image-slider";
import useResizer from "./../../services/useResizer";
import AppSVG from "../../assets/signInPageSlideImages/qrcode.svg";
import GooglePlay from "../../assets/svgs/google-play.svg";
import { isMobile } from "react-device-detect";
import UserIcon from "../../assets/svgs/user-icon.svg";
import PasswordEye from "../../assets/svgs/password-eye.svg";
import SwiperCore, {
  Autoplay,
  EffectFade,
  Navigation,
  Pagination,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import "swiper/swiper.scss"; // core Swiper
import "swiper/modules/navigation/navigation.scss"; // Navigation module
import "swiper/modules/pagination/pagination.scss"; // Pagination module

SwiperCore.use([Pagination, Navigation, Autoplay]);

export default function Signin(props) {
  const classes = useStyles();
  let history = useHistory();
  const location = useLocation();
  const [redirectTo, setRedirectTo] = useState(null);

  const isMobile = useResizer();

  const images = [
    { url: "../../assets/signInPageSlideImages/two.svg" },
    { url: "../../assets/signInPageSlideImages/three.svg" },
  ];

  const token = useSelector((state) => state.trading.TOKEN);
  let params = queryString.parse(location.search);

  if (token) {
    if (params.redir) {
      history.push(params.redir);
    } else {
      history.push("/trade/BTC");
    }
  }
  useEffect(() => {
    const redirectToState = location.state?.redirectTo;

    if (Boolean(redirectToState)) {
      setRedirectTo(redirectToState);
    }
  }, [location.state]);

  const [loginId, setLoginId] = useState(null);
  const [password, setPassword] = useState(null);
  const [verifCode, setVerifCode] = useState(null);
  const [verified, setVerified] = useState(false);
  const dispatch = useDispatch();

  const [isValid, setIsValid] = useState({ boo: true, message: "" });

  const [twoFA, setTwoFA] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(false);

  const [errorFields, setErrorFields] = useState({
    loginid: false,
    pass: false,
    otp: false,
  });

  const [openDialog, setOpenDialog] = useState(false);

  const [counter, setCounter] = useState(120);
  const [startTimer, setStartTimer] = useState(false);

  const [captcha, setCaptcha] = useState("");

  const [resendOtpText, setResendOtpText] = useState("");

  const handleClickOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    history.push(`/forgotpassword`);
  };

  const reRef = useRef();

  const ref = useRef();

  useEffect(() => {
    // if (window.innerWidth <= 768) {
    //   let timer = 1;
    //   let interval = setInterval(() => {
    //     timer++;
    //     if (detectIfFreshchatHasLoaded()) {
    //       document.querySelector(
    //         "#fc_frame, #fc_frame.fc-widget-normal"
    //       ).style.left = "0";
    //       clearInterval(interval);
    //     } else {
    //       if (timer >= 5) {
    //         clearInterval(interval);
    //       }
    //     }
    //   }, 1000);
    // }
  }, []);
  function detectIfFreshchatHasLoaded() {
    if (document.querySelector("#fc_frame, #fc_frame.fc-widget-normal")) {
      return true;
    } else {
      return false;
    }
  }
  const { handleClickAlert } = useContext(CoinContext);

  function check2FA() {
    if (loginId && !verified) {
      // console.log("checking 2FA");
      // if (loginId.length >= 10) {
      if (/^\d+$/.test(loginId) === false) {
        let re = /\S+@\S+\.\S+/;
        if (re.test(loginId)) {
          setErrorFields({
            ...errorFields,
            loginid: false,
          });
        } else {
          setErrorFields({
            ...errorFields,
            loginid: true,
          });
        }
      }
      fetcher(`/isUsing2FA?login=${loginId}`)
        .then((data) => {
          if (data === true) {
            setVerified(true);
            setTwoFA(true);
          } else if (data === false) {
            setVerified(false);
            setTwoFA(false);
          } else {
            setVerified(false);
            setTwoFA(false);
          }
          // console.log(data)
          // console.log("two factor auth", data);
          // console.log(`Verified? ${verified}`);
        })
        .catch((err) => {
          // console.error(err);
          console.error(err);
        });
      // }
    }
  }

  // useEffect(() => {
  //   if (loginId && !verified) {
  //     console.log("checking 2FA");
  //     let cancel;
  //     axios({
  //       method: "GET",
  //       url: REACT_APP_PROD_URL + `/isUsing2FA?login=${loginId}`,
  //       cancelToken: new axios.CancelToken((c) => (cancel = c)),
  //     })
  //       .then((res) => {
  //         if(res.status === 200){
  //           if(res.data === true){
  //             setVerified(true);
  //             setTwoFA(true);
  //           } else {
  //             setVerified(false);
  //             setTwoFA(false);
  //           }
  //         } else {
  //           setVerified(false);
  //           setTwoFA(false);
  //         }
  //         console.log(res)
  //       })
  //       .catch((e) => {
  //         if (axios.isCancel(e)) return;
  //       });

  //     return () => cancel();
  //   }
  // }, [loginId]);

  function submitForm() {
    if (verified) {
      if (loginId && password && verifCode) {
        setLoading(true);
        // console.log("Fetching token");
        // receiving cookies here
        fetcher(`/authenticate`, {
          method: "POST",
          body: {
            login: loginId,
            password: password,
            verificationCode: verifCode,
            clientKey: captcha,
          },
        })
          .then(async (data) => {
            if (data.id_token) {
              dispatch({ type: "SET_TOKEN", payload: data.id_token });
              dispatch({ type: "SET_LOGIN_ID", payload: loginId });
              deleteFreshchat();
              setTimeout(() => {
                if (loginId) {
                  if (loginId.includes("@")) {
                    window.fcWidget.user.setProperties({
                      email: loginId,
                    });
                    // window.fcWidget.user.setE(data.firstName);
                  } else {
                    window.fcWidget.user.setProperties({
                      phone: loginId,
                      phoneCountry: "+91",
                    });
                  }
                }
              }, 1000);

              // console.log(data);
              setErrorFields({
                loginid: false,
                pass: false,
                otp: false,
              });
              setLoading(false);
              handleClickAlert("success", "Successfully logged in!");

              if (params.redir) {
                history.push(params.redir);
              } else {
                history.push(`/trade/BTC`);
              }
            } else {
              setLoading(false);
              setIsValid({
                boo: false,
                message:
                  "Login failed, incorrect credentials. Please try again.",
              });
            }
          })
          .catch((err) => {
            setLoading(false);
            let readableError = err.info?.detail?.match(/"([^']+)"/)[1];
            setIsValid({
              boo: false,
              message: readableError,
            });
            console.error(err);
            // console.error(err);
          });
      } else {
        // setIsValid(false);
        setErrorFields({
          loginid: loginId ? false : true,
          pass: password ? false : true,
          otp: verifCode ? false : true,
        });
      }
    } else {
      verifyUser();
    }
  }

  async function verifyUser() {
    if (loginId && password) {
      const captchaToken = await reRef.current.executeAsync();
      setCaptcha(captchaToken);
      reRef.current.reset();

      setLoading(true);
      // console.log("Fetching verification code");
      Sentry.setUser({ email: loginId });
      fetcher(`/loginOtp`, {
        method: "POST",
        body: {
          login: loginId,
          password: password,
          clientKey: captchaToken,
        },
      })
        .then((res) => {
          setResendOtpText("Get OTP via Call");
          setStartTimer(true);
          setLoading(false);
          setVerified(true);
          setErrorFields({
            loginid: false,
            pass: false,
            otp: false,
          });
          setIsValid({
            boo: true,
            message: "",
          });

          res.detail?.toLowerCase() !== "Enter 2FA Code".toLowerCase() &&
          handleClickAlert("success", "OTP sent");

          if (res.status === 200) {
            if (res.detail?.toLowerCase() == "Enter 2FA Code".toLowerCase()) {
              setTwoFA(true);
            } else {
              setTwoFA(false);
            }
          }
          // console.log(res);
        })
        .catch((err) => {
          if (err.status === 406) {
            setLoading(false);
            // alert("Old PocketBits users pls reset your password");
            // history.push(`/forgotpassword`);
            handleClickOpenDialog();
          } else if (err.status === 403) {
            setLoading(false);
            setIsValid({
              boo: false,
              message: "Your account is under review. Please contact Support.",
            });
          } else {
            setLoading(false);
            setIsValid({
              boo: false,
              message: "Please make sure you have entered the correct details.",
            });
          }
          console.error(err);
          // console.error(err);
        });
    } else {
      // setIsValid(false);
      setErrorFields({
        loginid: loginId ? false : true,
        pass: password ? false : true,
        otp: false,
      });
    }
  }
  function resendOtp() {
    if (loginId && password) {
      // setStartTimer(true);
      // verifyUser();
      // if user has entered phone number
      // verifyUser();
      // if user has entered email

      fetcher(`/resendOtp?login=${loginId}&type=login`, {
        method: "GET",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
          "access-control-allow-origin": "*",
          "Access-Control-Allow-Credentials": true,
        },
      })
        .then((res) => {
          if (res.status === 200) {
            setVerified(true);
            res.detail?.toLowerCase() !== "Enter 2FA Code".toLowerCase()&&
            handleClickAlert("success", "OTP resent");
          } else {
            handleClickAlert("error", "OTP resend failed");
          }
          // console.log(res);
        })
        .catch((err) => {
          Sentry.captureException(err);
          // console.log(err);
        });
    } else {
      setErrorFields({
        ...errorFields,
        loginid: loginId ? false : true,
        pass: password ? false : true,
      });
    }
  }

  // useEffect(() => {
  //   const listener = event => {
  //     if (event.code === "Enter" || event.code === "NumpadEnter") {
  //       alert("Enter key was pressed. Run your function.");
  //       // callMyFunction();
  //     }
  //   };
  //   document.addEventListener("keydown", listener);
  //   return () => {
  //     document.removeEventListener("keydown", listener);
  //   };
  // }, []);

  // console.log("Verified?", verified)

  // for countdown timer for otp
  const padTime = (time) => {
    return String(time).length === 1 ? `0${time}` : `${time}`;
  };

  const format = (time) => {
    // Convert seconds into minutes and take the whole part
    const minutes = Math.floor(time / 60);

    // Get the seconds left after converting minutes
    const seconds = time % 60;

    //Return combined values as string in format mm:ss
    return `${minutes}:${padTime(seconds)}`;
  };

  useEffect(() => {
    let timer;
    if (counter > 0 && startTimer) {
      timer = setTimeout(() => setCounter((c) => c - 1), 1000);
    } else if (counter === 0) {
      setStartTimer(false);
      setCounter(120);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [counter, startTimer]);

  return (
    <div
      className={
        !isMobile ? classes.mainContainer : classes.mainContainerMobile
      }
    >
      <Container
        className={classes.root}
        component="main"
        maxWidth="xs"
        style={{
          background: "#1C212A",
          borderRadius: !isMobile ? "30px" : "15px",
          paddingTop: !isMobile ? "24px" : "16px",
          paddingBottom: !isMobile ? "24px" : "16px",
          minHeight: isMobile ? "0vh" : "65vh",
          width: "95%",
        }}
      >
        <CssBaseline />
        <div className={classes.paper}>
          <Typography
            variant="h4"
            className={classes.title}
            style={{ paddingBottom: "10px" }}
          >
            Log into PocketBits
          </Typography>
          {/* <p style={{ fontWeight: "bold", color: "#868786" }}>
            Enter your details below.
          </p> */}
          {/* <br></br> */}
          <Grid container justify="flex-start">
            <Grid item>
              <p style={{ color: "#FFFFFF" }}>
                Don't have an account?
                <span
                  onClick={() => {
                    history.push(`/createacc`);
                  }}
                  className={classes.link}
                  style={{ fontWeight: "500" }}
                >
                  {" "}
                  Sign up
                </span>
              </p>
            </Grid>
          </Grid>
          <div className={classes.form}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <p
                  style={{
                    color: "#868786",
                    marginTop: "0px",
                    paddingBottom: "4px",
                    // fontWeight: "bold",
                  }}
                >
                  Phone Number or Email ID
                </p>
                {/* {phoneNumber === null ? null : phoneNumber.length ===
                10 ? null : (
                <p style={{ color: "red", margin: 0 }}>
                  Phone number should be of 10 digits
                </p>
              )} */}
                <ClickAwayListener>
                  <TextField
                    className={classes.textfeildBackground}
                    variant="outlined"
                    size={isMobile ? "small" : "normal"}
                    required
                    fullWidth
                    id="loginId"
                    name="loginId"
                    onChange={(e) => {
                      // let val = e.target.value.replace(/[^a-zA-Z.@\d]/, "");
                      let val = e.target.value.replace(/\s/g, "");
                      setLoginId(val);
                      setVerified(false);
                    }}
                    value={loginId}
                    InputProps={{
                      inputProps: { maxLength: 50 },
                      endAdornment: (
                        <InputAdornment position="end">
                          <img src={UserIcon} />
                        </InputAdornment>
                      ),
                      classes: { notchedOutline: classes.noBorder },
                    }}
                    error={errorFields.loginid}
                    helperText={
                      errorFields.loginid
                        ? "Please enter correct phone number / email"
                        : null
                    }
                    onKeyUp={(event) => {
                      if (
                        event.key === "Enter" ||
                        event.key === "NumpadEnter"
                      ) {
                        submitForm();
                      }
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Tab") {
                        // check2FA();
                      }
                    }}
                  />
                </ClickAwayListener>
              </Grid>
              <Grid item xs={12}>
                <p
                  style={{
                    color: "#868786",
                    marginTop: "5px",
                    paddingBottom: "4px",
                    // fontWeight: "bold",
                  }}
                >
                  Password
                </p>
                <TextField
                  className={classes.textfeildBackground}
                  variant="outlined"
                  size={isMobile ? "small" : "normal"}
                  required
                  fullWidth
                  name="password"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  onChange={(e) => {
                    // removing spaces
                    let val = e.target.value.replace(/\s/g, "");
                    setPassword(val);
                  }}
                  value={password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {/* {showPassword ? <Visibility /> : <VisibilityOff />} */}
                        <img
                          src={PasswordEye}
                          aria-label="toggle password visibility"
                          // onMouseDown={() => setShowPassword(true)}
                          // onMouseUp={() => setShowPassword(false)}
                          onClick={() => {
                            setShowPassword(!showPassword);
                          }}
                          style={{ cursor: "pointer" }}
                        ></img>
                      </InputAdornment>
                    ),
                    classes: { notchedOutline: classes.noBorder },
                    inputProps: { maxLength: 50 },
                  }}
                  error={errorFields.pass}
                  helperText={
                    errorFields.pass ? "Please enter the password" : null
                  }
                  onKeyUp={(event) => {
                    if (event.key === "Enter" || event.key === "NumpadEnter") {
                      submitForm();
                    }
                  }}
                />
              </Grid>
              {verified ? (
                <Grid item xs={12}>
                  <p
                    style={{
                      color: "#868786",
                      marginTop: "14px",
                      fontWeight: "bold",
                      paddingBottom: "4px",
                    }}
                  >
                    {twoFA ? "2FA CODE" : "VERIFICATION CODE"}
                  </p>
                  <TextField
                    className={classes.textfeildBackground}
                    autoComplete={false}
                    size={isMobile ? "small" : "normal"}
                    variant="outlined"
                    required
                    fullWidth
                    name="verificationCode"
                    type="number"
                    id="verificationCode"
                    onChange={(e) => setVerifCode(e.target.value)}
                    error={errorFields.otp}
                    helperText={
                      errorFields.otp ? "Please enter the code" : null
                    }
                    onKeyUp={(event) => {
                      if (
                        event.key === "Enter" ||
                        event.key === "NumpadEnter"
                      ) {
                        submitForm();
                      }
                    }}
                    InputProps={{
                      classes: { notchedOutline: classes.noBorder },
                    }}
                  />
                </Grid>
              ) : null}
            </Grid>
            <Grid container justify="flex-start">
              <Grid item style={{ paddingTop: "15px" }}>
                <p
                  onClick={() => {
                    history.push(`/forgotpassword`);
                  }}
                  className={classes.link}
                >
                  Forgot your password?
                </p>
              </Grid>
              <div className={classes.grow} />
              {twoFA ? null : (
                <Grid
                  item
                  style={{ paddingTop: "15px" }}
                  // onClick={() => {
                  //   if (twoFA) {
                  //     handleClickAlert("error", "2FA is enabled");
                  //   } else {
                  //     resendOtp();
                  //   }
                  // }}
                >
                  {counter === 0 || counter === 120 ? (
                    <div
                      className={classes.link}
                      onClick={() => {
                        if (twoFA) {
                          handleClickAlert("error", "2FA is enabled");
                          setResendOtpText("Get OTP via Call");
                        } else {
                          resendOtp();
                          setResendOtpText("Get OTP via Call");
                        }
                      }}
                    >
                      {resendOtpText}
                    </div>
                  ) : (
                    <div>Get OTP on call in {format(counter)}</div>
                  )}
                </Grid>
              )}
            </Grid>
            {isValid.boo ? null : (
              <p style={{ color: "red", margin: 0, marginTop: "10px" }}>
                {isValid.message}
              </p>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={submitForm}
            >
              {verified ? "Sign In" : "Continue"}
            </Button>
            {/* <br></br> */}
            {/* <p className="text-[#868786] font-light">
              This site is protected by reCAPTCHA and the Google{" "}
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-[#868786] underline"
              >
                Privacy Policy
              </a>{" "}
              and{" "}
              <a
                href="https://policies.google.com/terms"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-[#868786] underline"
              >
                Terms of Service
              </a>{" "}
              apply.
            </p> */}
          </div>
          {/* <div>
          <SimpleImageSlider width={300} height={440} images={images} />
        </div> */}
        </div>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Welcome to the all new PocketBits! Reset your Password to proceed.
          </DialogTitle>
          {/* <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Welcome to the all new PocketBits! Reset your Password to proceed.
          </DialogContentText>
        </DialogContent> */}
          <DialogActions>
            <Button
              onClick={handleCloseDialog}
              color="primary"
              variant="outlined"
              style={{
                fontWeight: "bold",
                marginBottom: "10px",
                marginRight: "6px",
              }}
            >
              Reset Password
            </Button>
          </DialogActions>
        </Dialog>

        <Backdrop className={classes.backdrop} open={loading}>
          {/* <CircularProgress color="primary" /> */}
          <img src={loaderGif} alt="loading..." />
        </Backdrop>

        <ReCAPTCHA sitekey={SITE_KEY_CAPTCHA} size="invisible" ref={reRef} />
      </Container>
      <div
        className={classes.root}
        component="main"
        maxWidth="xs"
        style={
          !isMobile
            ? {
                width: "65%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "65vh",
              }
            : {
                width: "100%",
                display: "flex",
                justifyContent: "center",
                minHeight: "0vh",
                // alignItems: 'start',
                // marginTop: '10px'
              }
        }
      >
        <Swiper
          onInit={(swiper) => {
            ref.current = swiper;
          }}
          className="mySwiper"
          slidesPerView={1}
          pagination={{ clickable: true }}
          loop={true}
          autoplay={{ delay: 5000, disableOnInteraction: true }}
          style={{ width: "65%" }}
        >
          <SwiperSlide>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              <img
                style={
                  !isMobile
                    ? { width: "100%", height: "auto" }
                    : { width: "100%", height: "auto" }
                }
                src={
                  require("../../assets/signInPageSlideImages/Carousel1Login.png")
                    .default
                }
              ></img>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
                alignItems: "center",
              }}
            >
              <img
                style={
                  !isMobile
                    ? { width: "100%", height: "auto" }
                    : { width: "100%", height: "auto" }
                }
                src={
                  require("../../assets/signInPageSlideImages/Carousel2Login.png")
                    .default
                }
              ></img>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div
        style={
          !isMobile
            ? {
                height: "65vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "center",
              }
            : { display: "none" }
        }
      >
        {/* <img
          src-={require("../../assets/signInPageSlideImages/appSvg.svg").default}
          style={{
            height: "79px",
            width: "79px",
          }}
        ></img> */}
        <p style={{ marginBottom: "5px", fontSize: "12px" }}>Get it on</p>
        <img src={AppSVG}></img>
        <div
          style={{
            width: "90px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p style={{ marginTop: "5px", fontSize: "12px" }}>Google play</p>
          {/* <img
            style={{ marginTop: "5px" }}
            width="16"
            height="16"
            src={GooglePlay}
          ></img> */}
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    alignItems: "start",
    height: isMobile ? "auto" : "auto",
    // minHeight: isMobile?('20vh'):('65vh'),
    [theme.breakpoints.down("sm")]: {
      // maxWidth: "450px",
      // minWidth: "450px",
    },
    margin: 0,
  },
  rootCarousel: {
    width: "65%",
  },
  textfeildBackground: {
    backgroundColor: "#222830",
    borderRadius: "5px",
    "& #loginId-helper-text": {
      marginLeft: "0px",
      marginRight: "0px",
      paddingTop: "3px",
      paddingLeft: "14px",
      paddingRight: "14px",
      backgroundColor: "rgb(28, 33, 42);",
    },
    "& #password-helper-text": {
      marginLeft: "0px",
      marginRight: "0px",
      paddingTop: "3px",
      paddingLeft: "14px",
      paddingRight: "14px",
      backgroundColor: "rgb(28, 33, 42);",
    },
    "& #verificationCode-helper-text": {
      marginLeft: "0px",
      marginRight: "0px",
      paddingTop: "3px",
      paddingLeft: "14px",
      paddingRight: "14px",
      backgroundColor: "rgb(28, 33, 42);",
    },
  },
  mainContainer: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    borderRadius: "5px",
    height: "100vh",
    backgroundColor:
      "radial-gradient(195.32% 195.32% at -29.61% 64.11%, #262D41 0%, #131518 100%);",
    padding: "0 35px",
  },
  mainContainerMobile: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "70px",
  },
  paper: {
    // [theme.breakpoints.down("sm")]: {
    //   paddingTop: "200px",
    //   marginLeft: theme.spacing(4),
    //   marginRight: theme.spacing(4),
    // },
    // [theme.breakpoints.up("md")]: {
    //   paddingTop: theme.spacing(20),
    // },
    display: "flex",
    flexDirection: "column",
  },
  title: {
    alignItems: "left",
    fontWeight: 800,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: !isMobile ? theme.spacing(3) : theme.spacing(1),
    alignItems: "center",
  },
  submit: {
    margin: !isMobile ? theme.spacing(3, 0, 2) : "10px 0px",
    // width: "150px",
    width: "100%",
    height: "45px",
    color: "white",
    fontWeight: 600,
  },
  grow: {
    flexGrow: 1,
  },
  link: {
    fontWeight: "bold",
    color: "#3AC4AB",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  noBorder: {
    border: "none",
  },
}));
